import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { PaymentPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { PaymentTransfersDataTable } from 'modules/banking/components/PaymentTransfersDataTable'
import { useMarkAsPaidPaymentExecution } from 'modules/banking/hooks/useMarkAsPaidPaymentExecution'
import { useRevokeTransfersMutation } from 'modules/banking/hooks/useRevokeTransfers'
import { useUpdateSepaFile } from 'modules/banking/hooks/useUpdateSepaFile'
import { lastPaymentExecutionfromPaymentDetail } from 'modules/banking/lib/paymentHelpers'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const PaymentPage = () => {
  const { id } = useParams()
  const { updateSepaFile, processDownload } = useUpdateSepaFile()
  const { markAsPaidPaymentExecution } = useMarkAsPaidPaymentExecution()

  const { submitRevokeTransfers } = useRevokeTransfersMutation()

  const { data, loading, error, refetch } = useQuery(PaymentPageDocument, {
    variables: { id: Number(id) },
  })
  const canSeePaymentsModule =
    !!data?.finance?._policies?.sidebarSeeFinancePaymentsSubLevelItem?.can

  const payment = data?.banking?.payment
  if (!payment) return <></>

  const paymentExecution = lastPaymentExecutionfromPaymentDetail(payment)
  if (!paymentExecution) return <></>

  const legalEntitiesOptions =
    data?.companies.legalEntities.flatMap((p) => {
      return { label: p.legalName, value: p.id }
    }) || []

  const requestersOptions =
    paymentExecution.transfers
      .flatMap((transfer) => {
        return { label: transfer.requester.access.fullName, value: transfer.requester.id }
      })
      .filter((option, index, self) => index === self.findIndex((o) => o.value === option.value)) ||
    []

  const downloadSepaAction = () => {
    if (paymentExecution.sepaFile?.url) {
      processDownload(paymentExecution.sepaFile.url, paymentExecution.sepaFile.filename)
    } else {
      updateSepaFile(paymentExecution.id)
    }
  }

  const handleSubmitRevokeTransfer = async (transferId: number) => {
    await submitRevokeTransfers({
      transferIds: [transferId],
      paymentId: Number(id),
    })
    refetch({ id: Number(id) })
  }

  return (
    <ResponsivePage.Body
      error={error}
      loading={loading}
      authorized={canSeePaymentsModule}
      variant="full"
      onSecondaryActionClick={(key) => {
        if (key === 'download_sepa_file') {
          downloadSepaAction()
        } else if (key === 'mark_as_paid') {
          markAsPaidPaymentExecution(paymentExecution.id)
        }
      }}
    >
      <Box flexDirection="column" gap="s32">
        {paymentExecution && (
          <PaymentTransfersDataTable
            paymentExecution={paymentExecution}
            onRevokeTransfer={handleSubmitRevokeTransfer}
            legalEntitiesOptions={legalEntitiesOptions}
            requestersOptions={requestersOptions}
          />
        )}
      </Box>
    </ResponsivePage.Body>
  )
}

export default PaymentPage
